import React, { useContext, useCallback, useEffect } from 'react';
import { t, Trans } from '@lingui/macro';
import { connect } from 'react-redux';
import { LaptopOutlined, DeleteOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Input, Row, Upload, Modal } from 'antd';
import { FileContext } from '../Provider';
import { FileViewHelper } from '../helper.view';
import { usePrevious } from '../../../helpers/useReadStateSuccess';
import { ConditionalTooltip } from '../../Tooltip/ConditionalTooltip';

export function DeleteButton() {
    const fileContext = useContext(FileContext);
    const { contextState, contextProps } = fileContext;
    const { rowList } = contextState;
    const { onOk } = contextProps;

    const deleteFiles = () => {
        Modal.confirm({
            title: t`Delete Files`,
            ...FileViewHelper.getDeleteConfirmationModalProps(onOk, rowList),
        });
    };
    return (
        <Col>
            <ConditionalTooltip
                rules={[{
                    condition: !rowList.filter(f => !f.used_count).length,
                    message: t`Select at least one not In Use file for deletion.`,
                }]}
                tooltipProps={{
                // arrowPointAtCenter: true,
                    arrow: {pointAtCenter: true},
                }}
            >
                <Button
                    onClick={deleteFiles}
                    icon={<DeleteOutlined />}
                    danger
                    disabled={!rowList.filter(f => !f.used_count).length}
                >
                    <Trans>
                        Delete (
                        {rowList.filter(f => !f.used_count).length}
                        )
                    </Trans>
                </Button>
            </ConditionalTooltip>
        </Col>
    );
}

function SearchBar() {
    const fileContext = useContext(FileContext);
    const { contextProps, contextAction } = fileContext;

    const { isFileManager } = contextProps; // for different visuals
    const { onSearch } = contextAction;

    const pageWidthProps = {
        flex: "0 1 260px",
    };
    const modalWidthProps = {
        xs: 14,
        sm: 12,
        md: 9,
    };

    return (
        <Col
            // xs={24}
            // xs={14}
            // sm={isFileManager ? 16 : 12}
            // md={isFileManager ? 16 : 9}
            {...isFileManager ? pageWidthProps : modalWidthProps}
            style={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Input.Search
                allowClear
                placeholder={t`Search Files`}
                style={{
                    width: '100%',
                    marginRight: '5px',
                }}
                onSearch={onSearch}
            />
        </Col>
    );
}

export const UploadButton = connect(state => ({
    view: state.App.view,
}), {})(({view}) => {
    const fileContext = useContext(FileContext);

    const { contextProps, contextState, contextAction } = fileContext;
    const { uploading } = contextState;
    const { isFileManager } = contextProps; // for different visuals
    const { getUploadProps } = contextAction;

    const prevUploadingLen = usePrevious(uploading.length);

    // to solve issue for scrolling in control panel page when uploading
    // for firefox as it doesn't support :has() css --> :has(.header-extra-ignore-scroll)
    useEffect(() => {
        if (isFileManager && prevUploadingLen === 0 && uploading.length !== 0) {
            const pageHeaderExtra = document.querySelector('.ant-page-header-heading-extra');
            pageHeaderExtra.style.overflowX = 'unset';
        }
    });

    const BadgeWrapper = useCallback(
        ({ children }) => {
            if (uploading.length !== 0) {
                return (
                    <Badge count={uploading.length} className="header-extra-ignore-scroll">
                        {children}
                    </Badge>
                );
            }
            return children;
        },
        [uploading],
    );

    return (
        <Col
            xs={10}
            sm={12}
            md={12}
            style={isFileManager ? null : {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
            }}
        >
            <Upload {...getUploadProps()} className="top-button">
                <BadgeWrapper>
                    <Button
                        icon={<LaptopOutlined />}
                        type="primary"
                        size="default"
                        loading={!!uploading.length}
                    >
                        {
                            isFileManager || view === 'MobileView' ?
                                <Trans>Upload</Trans> :
                                <Trans>Upload from Device</Trans>
                        }
                    </Button>
                </BadgeWrapper>
            </Upload>
        </Col>
    );
});

function Topbar() {
    const fileContext = useContext(FileContext);

    const { contextProps } = fileContext;
    const { isFileManager } = contextProps; // for different visuals

    return (
        <Row
            gutter={[12, 12]}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 12,
            }}
        >
            <SearchBar />
            {isFileManager ? <DeleteButton /> : <UploadButton />}
        </Row>
    );
}

export const ModalTopbar = connect(() => ({}), {})(Topbar);
